import React, { Component } from 'react';
import { Card, Table } from 'antd';
import moment from 'moment';
import util from '@util';
import { queryFilePreview } from '@api/pub/attachment';

class WriteForm extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  columns = () => {
    return [
      {
        title: '序号',
        dataIndex: 'num',
        key: 'num',
        width: '6%',
        render: (text, record, index) => {
          return <span>{index + 1}</span>;
        },
      },
      {
        title: '核销人',
        dataIndex: 'createUserName',
        key: 'createUserName',
      },
      {
        title: '核销类型',
        dataIndex: 'type',
        key: 'type',
        render: text => {
          if (text === 0) {
            return '借款归还';
          }
          if (text === 1) {
            return '发票冲销';
          }
          return '';
        },
      },
      {
        title: '核销时间',
        dataIndex: 'date',
        key: 'date',
        render: text => {
          if (text) {
            return moment.unix(text / 1000).format('YYYY-MM-DD HH:mm');
          }
          return '-';
        },
      },
      {
        title: '核销金额',
        dataIndex: 'price',
        key: 'price',
        render: text => {
          return util.numberFormat(text, 2, '.', ',');
        },
      },
      {
        title: '附件',
        dataIndex: 'files',
        key: 'files',
        render: text => {
          return text.map(item => {
            return (
              <div key={item.url}>
                <a onClick={() => queryFilePreview(item)}> {item.name}</a>
              </div>
            );
          });
        },
      },
    ];
  };

  render() {
    const { data } = this.props;
    return (
      <Card title="借款核销详情">
        <Table
          rowKey={record => record.uuid}
          columns={this.columns()}
          dataSource={data}
          pagination={false}
          size="small"
        />
      </Card>
    );
  }
}

export default WriteForm;



// WEBPACK FOOTER //
// ./src/components/finance/loan/FormWrite.js